<template>
  <v-container>
    <v-row>
      <v-col md="12">
        <v-card flat>
          <v-text-field
            v-model="search"
            label="Filter Users By Name"
            type="text"
            @change="applySearch"
          ></v-text-field>
          <v-data-table
            v-model="selectedTable"
            :headers="headers"
            :options.sync="options"
            :server-items-length="serverItemsLength"
            :loading="loading"
            :items="users"
            item-key="id"
            show-select
            @item-selected="selectItem"
          ></v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { EventBus } from "@/event-bus.js";
import userAPI from "@/api/user.js";
import groupAPI from "@/api/group.js";
import channelAPI from "@/api/channel.js";
import courseAPI from "@/api/course.js";
export default {
  name: "UsersAdmin",
  props: {
    type: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    extendedView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      defaultHeaders: [
        { text: "", value: "", sortable: false },
        { text: "First Name", value: "first_name" },
        { text: "Surname", value: "last_name" },
        { text: "Email", value: "email" }
      ],
      extendedHeaders: [
        { text: "", value: "", sortable: false },
        { text: "First Name", value: "first_name" },
        { text: "Surname", value: "last_name" },
        { text: "Email", value: "email" },
        { text: "Deadline", value: "deadline" }
      ],
      users: [],
      search: "",
      pagination: {},
      options: {},
      loading: false,
      selectedUsers: [],
      selectedUserCount: 0,
      meta: {},
      existingUsers: [],
      existingUsersInit: false,
      selectedTable: []
    };
  },
  computed: {
    serverItemsLength: function() {
      return this.pagination.total;
    },
    itemsPerPage: function() {
      return this.pagination.per_page;
    },
    page: function() {
      return this.pagination.current_page;
    },
    params: function() {
      return this.$gf.getQueryString(this.options);
    },
    headers() {
      return this.extendedView ? this.extendedHeaders : this.defaultHeaders;
    }
  },
  watch: {
    options: {
      handler() {
        this.getUsers();
      },
      deep: true
    }
  },
  methods: {
    selectItem(e) {
      this.selectedUsers.includes(e.item.id)
        ? this.removeUser(e.item.id)
        : this.pushUser(e.item.id);
    },
    applySearch() {
      this.params =
        this.params +
        "&search=first_name:" +
        this.search +
        ";last_name:" +
        this.search;
      this.getUsers();
    },
    getUsers() {
      this.loading = true;
      switch (this.type) {
        case "courses":
          courseAPI
            .getCourseUnenrolledUsers(this.id, this.params)
            .then(resp => {
              this.loading = false;
              this.users = resp.data.all.data;
              this.pagination = resp.data.meta.current_page;
            });
          break;
        case "groups":
          groupAPI.getGroupUsersWithState(this.id, this.params).then(resp => {
            this.loading = false;
            this.users = resp.data.all.data;
            this.selectedTable = resp.data.members.data;

            this.pagination = resp.data.meta.current_page;
            if (!this.existingUsersInit) {
              this.existingUsers = resp.data.members.data;
              this.populateMembersArray();
            } else {
              this.targetExisting();
            }
          });
          break;
        case "channels":
          channelAPI
            .getChannelUsersWithState(this.id, this.params)
            .then(response => {
              this.loading = false;
              this.users = response.data.all.data;
              this.meta = response.data.all.meta.pagination;
              this.pagination.page = this.meta.current_page;
              this.pagination.rowsPerPage = this.meta.per_page;
              this.pagination.totalItems = this.meta.total;
              if (!this.existingUsersInit) {
                this.existingUsers = response.data.members.data;
                this.populateMembersArray();
              } else {
                this.targetExisting();
              }
            });
          break;
        case "manage":
          courseAPI
            .getCourseEnrolledUsers(this.id, this.params)
            .then(response => {
              this.loading = false;
              this.users = response.data.all.data;
              this.meta = response.data.all.meta.pagination;
              this.pagination.page = this.meta.current_page;
              this.pagination.rowsPerPage = this.meta.per_page;
              this.pagination.totalItems = this.meta.total;
            });
          break;
        default:
          userAPI.getClients(this.params).then(response => {
            this.loading = false;
            this.users = response.data.data;
            this.pagination = this.$gf.setPagingParams(
              this.pagination,
              response.data.meta
            );
            this.targetExisting();
          });
      }
    },
    disableExisting() {
      this.existingUsersInit = true;
      const members = [];
      this.existingUsers.forEach(function(x) {
        members.push(x.id);
      });
      this.selectedUsers = members;
      this.selectedUserCount = members.length;
      this.fireEventBus();
      this.targetExisting();
    },
    targetExisting() {
      for (var i = 0; i < this.users.length; i++) {
        if (this.selectedUsers.indexOf(this.users[i].id) !== -1) {
          this.users[i].checked = true;
        }
      }
    },
    populateMembersArray() {
      this.existingUsersInit = true;
      const members = [];
      this.existingUsers.forEach(function(x) {
        members.push(x.id);
      });
      this.selectedUsers = members;
      this.selectedUserCount = members.length;
      this.fireEventBus();
      this.targetExisting();
    },
    fireEventBus() {
      EventBus.$emit("USER_SELECTED", {
        selectedUsers: this.selectedUsers,
        selectedUserCount: this.selectedUserCount
      });
    },
    selectUser(id) {
      this.selectedUsers.includes(id) ? this.removeUser(id) : this.pushUser(id);
    },
    pushUser(id) {
      this.selectedUsers.push(id);
      this.selectedUserCount = this.selectedUsers.length;
      this.fireEventBus();
    },
    removeUser(id) {
      for (var i = 0; i < this.selectedUsers.length; i++) {
        if (this.selectedUsers[i] === id) {
          this.selectedUsers.splice(i, 1);
        }
      }
      this.selectedUserCount = this.selectedUsers.length;
      this.fireEventBus();
    }
  }
};
</script>
